import dayjs from "dayjs";
import ImageWithBasePath from "../../../../../../core/common/imageWithBasePath";
import { useEffect } from "react";

const MultiplePagePdfCustomCountertop = ({ printRef, printOutPdfDetails, onRenderReady }: any) => {


    const formatDate = (date: Date | string) => {
        return dayjs(date).format("MMM-D-YYYY").toUpperCase();
    };
    const formattedDate = formatDate(new Date());
    useEffect(() => {
        if (printOutPdfDetails) {
            onRenderReady?.();
        }
    }, [printOutPdfDetails]);
    return (
        <div className="p-5">
            <div ref={printRef} className="d-flex flex-column gap-4" id="23">
                {/* Page 1 */}
                <div className="position-relative" style={{ height: "270mm", backgroundColor: "#fff", padding: "2rem", overflow: "hidden", pageBreakAfter: "always" }}>
                    <header className="w-100 py-3 f-f text-center">
                        <div className="row mb-6 justify-content-between align-items-center">
                            <div className='col-md-6' style={{ flex: '0 0 50%', maxWidth: '50%' }} >
                                <div className='d-flex align-items-center justify-content-center text-center'>
                                    <ImageWithBasePath
                                        src={'assets/img/logo.svg'}
                                        className=""
                                        alt="Logo"
                                        width={300}
                                        height={68}
                                    />
                                </div>
                            </div>
                            <div className='col-md-6 d-flex flex-column justify-content-center align-items-center' style={{ flex: '0 0 50%', maxWidth: '50%' }} >
                                <div className="" style={{ textAlign: 'justify' }}>
                                    <div className='d-flex mb-2 f-f fs-16'>
                                        <p className="text-sm w-20 mb-0 ">Buyer's Name:</p>
                                        <p className="text-sm mb-0">{printOutPdfDetails?.result?.primaryContactFirstName + " " + printOutPdfDetails?.result?.primaryContactLastName}
                                        </p>
                                    </div>
                                    <div className='d-flex mb-2 f-f fs-16'>
                                        <p className="text-sm w-20 mb-0">Address:</p>
                                        <p className="text-sm  mb-0">{printOutPdfDetails?.result?.propertyAddressLine1}
                                        </p>
                                    </div>
                                    <div className='d-flex mb-2 f-f fs-16'>
                                        <p className="text-sm w-20 mb-0">City, State, ZIP:</p>
                                        <span className="text-sm mb-0" style={{ whiteSpace: "nowrap"}}>
                                            {`${printOutPdfDetails?.result?.propertyCity || ''}${printOutPdfDetails?.result?.propertyCity ? ', ' : ''
                                                }${printOutPdfDetails?.result?.propertyState || ''}${printOutPdfDetails?.result?.propertyState ? ', ' : ''
                                                }${printOutPdfDetails?.result?.propertyZipCode || ''}`}
                                        </span>
                                    </div>
                                    <div className='d-flex mb-2 f-f fs-16'>
                                        <p className="text-sm w-20 mb-0">Project#: </p>
                                        <p className="text-sm  mb-0">{printOutPdfDetails?.result?.projectNumber}</p>
                                    </div>
                                    <div className='d-flex mb-2 f-f fs-16'>
                                        <p className="text-sm w-20 mb-0">Date: </p>
                                        <p className="text-sm  mb-0">{formattedDate}</p>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </header>
                    <main className="mt-2 mb-1 py-2 text-center f-f">
                        <h4 className="text-center font-bold  mb-4 mt-3 fs-19 f-f">Custom Countertop Slab Selection Agreement</h4>
                        <div style={{ textAlign: 'justify' }}>
                            I have made my final stone slab selections as noted below and understand that Airoom will now place
                            a non-refundable deposit on this material. This particular stone slab can be released to the countertop
                            fabricator and is not returnable. I understand that if I choose to make a change to my countertop stone
                            selection after the date of this agreement, additional charges will apply.
                            <div className='d-flex mt-5 align-items-baseline '>
                                <div className='w-20'>Stone Yard:</div>
                                <div className="mt-4 w-100" style={{ borderBottom: "1px solid gray" }}></div>
                            </div>
                            <div className='d-flex mt-5  align-items-baseline'>
                                <div className='w-20'>Stone Slab:</div>
                                <div className="mt-4 w-100" style={{ borderBottom: "1px solid gray" }}></div>
                            </div>
                            <div className='d-flex mt-5  align-items-baseline'>
                                <div className='w-20'>Cost to Change:</div>
                                <div className="mt-4 w-100" style={{ borderBottom: "1px solid gray" }}></div>
                            </div>
                        </div>
                        <div className='d-flex justify-content-around' style={{ marginTop: '80px' }}>
                            <p>Airoom Client: __________________________</p>
                            <p>Date: {formattedDate}</p>
                        </div>
                        <div className='d-flex justify-content-around'>
                            <p>Airoom Client: __________________________</p>
                            <p>Date: {formattedDate}</p>
                        </div>
                    </main>
                    <footer className="position-absolute bottom-0 w-100 py-2 text-center">
                        <hr className="border-gray-300 bottom-0 my-4 mt-5" />
                        <p className='text-center fs-10 f-f fw-600'>DESIGN & BUILD SHOWROOM | 6825 N. LINCOLN AVE., LINCOLNWOOD IL 60712 | 847-485-1763
                            <br />
                            DESIGN STUDIO | 36 S. WASHINGTON ST., HINSDALE IL 60521 | 630-280-3380
                            <a href='https://Airoom.com'> Airoom.com</a>
                        </p>
                    </footer>
                </div>

                {/* Page 2 */}
                <div className="position-relative" style={{ height: "270mm", backgroundColor: "#fff", padding: "2rem", overflow: "hidden", pageBreakAfter: "always" }}>
                    <header className="w-100 py-3 text-center">
                        <div className="row mb-6 justify-content-between align-items-center">
                            <div className='col-md-12'>
                                <div className='d-flex align-items-center justify-content-center text-center'>
                                    <ImageWithBasePath
                                        src={'assets/img/logo-small.svg'}
                                        className=""
                                        alt="Logo"
                                        width={90}
                                        height={48}
                                    />
                                </div>
                            </div>
                            {/* <div className='col-md-6 d-flex flex-column justify-content-center align-items-center'>
                                <div className="">
                                    <div className='d-flex mb-2 f-f fs-16'>
                                        <p className="text-sm w-20 mb-0 ">Client Name:</p>
                                        <p className="text-sm mb-0">{printOutPdfDetails?.result?.primaryContactFirstName + " " + printOutPdfDetails?.result?.primaryContactLastName}
                                        </p>
                                    </div>
                                    <div className='d-flex mb-2 f-f fs-16'>
                                        <p className="text-sm w-20 mb-0">Address:</p>
                                        <p className="text-sm  mb-0">{printOutPdfDetails?.result?.propertyAddressLine1}
                                        </p>
                                    </div>
                                    <div className='d-flex mb-2 f-f fs-16'>
                                        <p className="text-sm w-20 mb-0">City, State, ZIP:</p>
                                        <p className="text-sm  mb-0">{
                                            `${printOutPdfDetails?.result?.propertyCity || ''}${printOutPdfDetails?.result?.propertyCity ? ', ' : ''}${printOutPdfDetails?.result?.propertyState || ''}${printOutPdfDetails?.result?.propertyState ? ', ' : ''}${printOutPdfDetails?.result?.propertyZipCode || ''}`
                                        }</p>
                                    </div>
                                    <div className='d-flex mb-2 f-f fs-16'>
                                        <p className="text-sm w-20 mb-0">Project#: </p>
                                        <p className="text-sm  mb-0">{printOutPdfDetails?.result?.projectNumber}</p>
                                    </div>
                                    <div className='d-flex mb-2 f-f fs-16'>
                                        <p className="text-sm w-20 mb-0">Date: </p>
                                        <p className="text-sm  mb-0">{formattedDate}</p>
                                    </div>
                                </div>
                            </div> */}
                        </div>

                    </header>
                    <main className="mt-2 mb-1 py-2 text-center f-f">
                        <h4 className="text-center font-bold  mb-4 mt-3 fs-19 f-f">Cabinetry Finish Acknowledgement</h4></main>
                    <div style={{ textAlign: 'justify' }}>
                        <div className="">
                            The undersigned understands their responsibility and acknowledges the conditions of this declaration and will
                            not hold Airoom LLC responsible for these characteristics.
                        </div>
                        <div className='d-flex justify-content-around mt-5'>
                            <p>Airoom Client: __________________________</p>
                            <p>Date: {formattedDate}</p>
                        </div>
                        <div className='d-flex justify-content-around mt-5'>
                            <p>Airoom Client: __________________________</p>
                            <p>Date: {formattedDate}</p>
                        </div>
                        <div className='d-flex justify-content-around mt-5'>
                            <p>Airoom Rep: &nbsp;&nbsp;&nbsp;___________________________</p>
                            <p>Date: {formattedDate}</p>
                        </div>
                    </div>
                    <footer className="position-absolute bottom-0 w-100 py-2 text-center">
                        <hr className="border-gray-300 bottom-0 my-4 mt-5" />
                        <p className='text-center fs-10 f-f fw-600'>DESIGN & BUILD SHOWROOM | 6825 N. LINCOLN AVE., LINCOLNWOOD IL 60712 | 847-485-1763
                            <br />
                            DESIGN STUDIO | 36 S. WASHINGTON ST., HINSDALE IL 60521 | 630-280-3380
                            <a href='https://Airoom.com'> Airoom.com</a>
                        </p>
                    </footer>
                </div>
            </div>
        </div>

    );
};

export default MultiplePagePdfCustomCountertop;
